export default {
  homePageUrl: '/',
  imprintPageUrl: '/imprint',
  dataProtectionPageUrl: '/privacy-policy',
};
